// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"eda14c6c","453":"c16e7c52"}[chunkId] + ".chunk.js";
};